import { Map, fromJS } from "immutable";
import { combineReducers } from "redux";
import * as actionTypes from "~/store/action_types";

export const item = (state = Map(), action) => {
  switch (action.type) {
    case actionTypes.ADD_REACTION_LOADING: {
      return Map({
        id: action.id,
        class: action.reactionType,
        parent_id: action.parentId,
        parent_type: action.parentType,
        created_by_id: action.createdById,
        pending: true,
      });
    }
    case actionTypes.ADD_REACTION_SUCCESS: {
      const { response = { entities: {}, result: {} } } = action;
      const { entities = { reactions: {} } } = response;
      const { reactions = {} } = entities;
      const { result = { single: {} } } = response;
      const { single = {} } = result;
      return Map(reactions[single]);
    }
    case actionTypes.ADD_REACTION_FROM_EVENT_STREAM_SUCCESS: {
      const { response = { entities: {}, result: {} } } = action;
      const { entities = { reactions: {} } } = response;
      const { reactions = {} } = entities;
      const { result } = response;
      return Map(reactions[result]);
    }
    default:
      return state;
  }
};

const collection = (state = Map(), action) => {
  switch (action.type) {
    case actionTypes.FETCH_COMMENTS_SUCCESS:
    case actionTypes.FETCH_CONVERSATIONS_SUCCESS:
    case actionTypes.FETCH_CONVERSATION_MESSAGES_SUCCESS:
    case actionTypes.LOAD_TASK:
    case actionTypes.FETCH_DISCUSSION_SUCCESS:
    case actionTypes.PREFETCH_DISCUSSION_SUCCESS:
    case actionTypes.FETCH_NOTE_SUCCESS:
    case actionTypes.FETCH_CALENDAR_EVENT_SUCCESS:
    case actionTypes.ANGULAR_INIT_TASK_AND_COMMENTS_MODAL: {
      const { response = { entities: {} } } = action;
      const { entities = { reactions: {} } } = response;
      const { reactions = {} } = entities;
      return state.merge(fromJS(reactions));
    }
    case actionTypes.REMOVE_REACTION_FROM_EVENT_STREAM_SUCCESS: {
      const { response = { result: {} } } = action;
      const { result } = response;
      return state.remove(`${result}`);
    }
    case actionTypes.ADD_REACTION_FROM_EVENT_STREAM_SUCCESS: {
      const { response = { result: {} } } = action;
      const { result } = response;
      return state.set(`${result}`, item(undefined, action));
    }
    case actionTypes.ADD_REACTION_LOADING: {
      return state.set(`${action.id}`, item(undefined, action));
    }
    case actionTypes.ADD_REACTION_SUCCESS: {
      const { response = { result: {} } } = action;
      const { result = { single: undefined } } = response;
      const { single = undefined } = result;
      state = state.remove(`${action.id}`);
      if (single) {
        return state.set(`${single}`, item(undefined, action));
      }
      return state;
    }
    case actionTypes.ADD_REACTION_ERROR: {
      return state.remove(`${action.id}`);
    }
    case actionTypes.REMOVE_REACTION_SUCCESS: {
      const { reactionId = undefined } = action;
      return reactionId ? state.remove(`${reactionId}`) : state;
    }
    default:
      return state;
  }
};

const types = (state = Map(), action) => {
  switch (action.type) {
    case actionTypes.FETCH_AVAILABLE_REACTIONS_SUCCESS: {
      const { response = { entities: {} } } = action;
      const { entities = { available_reactions: {} } } = response;
      const { available_reactions = {} } = entities;
      return fromJS(available_reactions);
    }
    default:
      return state;
  }
};

const myWorkCollection = (state = Map(), action) => {
  switch (action.type) {
    case actionTypes.FETCH_MY_WORK_REACTIONS: {
      if (action.response && action.response.objects_and_updates) {
        action.response.objects_and_updates.forEach((parent) => {
          return (state = state.setIn([`${parent.object.class}`, `${parent.object.id}`], fromJS(parent.reactions)));
        });
      }
      return state;
    }
    default:
      return state;
  }
};

export default combineReducers({
  collection,
  types,
  myWorkCollection,
});
